import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const fetchSearchedRunHistory = async (
  testSuiteId,
  testSuiteResultId,
  searchKey,
  page = 1,
  filters = {},
) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const encodedSearchKey = encodeURIComponent(searchKey);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getSearchedTestCaseHistoryForTestsuite&companyid=${user.companyid}&testSuiteId=${testSuiteId}&testSuiteResultId=${testSuiteResultId}&pnum=${page}&searchKey=${encodedSearchKey}`,
    {
      issueTypes: filters.issueTypes?.length > 0 ? filters.issueTypes : undefined,
      descriptionTags: filters.descriptionTags?.length > 0 ? filters.descriptionTags : undefined,
    },
  );

  return response.data;
};
const useSearchRunHistoryQuery = (
  testSuiteId,
  testSuiteResultId,
  searchKey,
  page = 1,
  filters = {},
  options = {},
) => {
  return useQuery({
    queryKey: ["searchRunHistory", testSuiteId, testSuiteResultId, searchKey, page, filters],
    queryFn: () =>
      fetchSearchedRunHistory(testSuiteId, testSuiteResultId, searchKey, page, filters),
    enabled: !!testSuiteId && !!searchKey && searchKey.length > 1 && options.enabled !== false,
    retry: true,
    refetchOnWindowFocus: false,
    staleTime: 0,
    ...options,
  });
};

export default useSearchRunHistoryQuery;
